<section class="mobile-sports-bar sb-panel" [attr.aria-label]="'sportsMenu.mobileLabel' | translate" [attr.aria-busy]="loading()">
  @if (loading()) {
    <span class="mobile-sports-bar__sr-only">{{ 'home.loading' | translate }}</span>
  }

  <div class="mobile-sports-bar__scroller sb-scrollbar">
    @if (loading()) {
      @for (index of skeletonIndexes; track index) {
        <div class="mobile-sports-bar__item mobile-sports-bar__item--skeleton" aria-hidden="true">
          <span class="mobile-sports-bar__indicator" aria-hidden="true"></span>
          <span class="mobile-sports-bar__icon">
            <span class="mobile-sports-bar__skeleton mobile-sports-bar__skeleton--icon"></span>
          </span>
        </div>
      }
    } @else {
      @for (sport of sports(); track trackSport($index, sport)) {
        <button
          type="button"
          class="mobile-sports-bar__item"
          [class.mobile-sports-bar__item--selected]="sport.selected"
          [attr.aria-label]="sport.label"
          [attr.aria-pressed]="sport.selected"
          [title]="sport.label"
          (click)="sportToggle.emit(sport.id)"
        >
          <span class="mobile-sports-bar__indicator" aria-hidden="true"></span>
          <span class="mobile-sports-bar__icon">
            <app-sport-icon [name]="sport.iconName"></app-sport-icon>
          </span>
        </button>
      }
    }
  </div>
</section>
